import React from "react";
import { useDispatch, useSelector } from "react-redux";
import FileImportModal from "../Shared/FileImportModal";
import { importAtbasOrdersFile } from "redux/slices/atbasOrdersImportSlice";

const TEMPLATE_PATH = "/assets/templates/Vorlage für ATBAS Scan Import.xlsx";

const ImportAtbasOrderModal = ({ open, onClose, t, onImportComplete }) => {
  const dispatch = useDispatch();
  const { importErrors } = useSelector((state) => state.atbasOrdersImport || { importErrors: [] });

  const handleImport = async (file, date, departure) => {
    try {
      const response = await dispatch(importAtbasOrdersFile(file, date, departure, t));
      return response;
    } catch (error) {
      return { success: false, errors: [] };
    }
  };

  return (
    <FileImportModal
      open={open}
      onClose={onClose}
      t={t}
      onImportComplete={onImportComplete}
      onImport={handleImport}
      showDateDeparture={true}
      title={t("atbas_scan_import")}
      description={
        <>
          {t("atbas_scan_import_desc_line_1")}
          <br />
          {t("atbas_scan_import_desc_line_2")}
        </>
      }
      templateUrl={encodeURI(TEMPLATE_PATH)}
      templateName={t("atbas_scan_import_template")}
      acceptedFileTypes={[
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ".xlsx",
        ".xls",
      ]}
      errorMessage="atbas_orders_import_error_heading"
      importErrors={importErrors}
      multilineImportErrors
    />
  );
};

export default ImportAtbasOrderModal;
